import React from 'react'
import DocumentTitle from 'react-document-title'
import RecordNav from './recordNav'
import PropertyActions from './propertyActions'
import GISMap from '_/shared/components/gisMap'

/**
 * GIS
 */
class GIS extends React.Component {
  static propTypes = {
    account: React.PropTypes.object.isRequired,
    property: React.PropTypes.object.isRequired,
  }

  static fetchData (store, { params }) {
    return {
      property: store.get(`/properties/${params.id}`, { expanded: true })
    }
  }

  handleShareToggle () {
    const { property } = this.state
    this.setState({ property: property.set('unsharable', !property.get('unsharable')) })
  }

  render() {
    const {property, account} = this.props

    return (
      <DocumentTitle title="Property - GIS">
        <div>
          <RecordNav property={property} account={account} onShareToggle={::this.handleShareToggle}>
            <PropertyActions
              account={account}
              property={property}
              editing={false} />
          </RecordNav>

          <GISMap
            county={property.get('county')}
            pin={property.get('pid')}
          />
        </div>
      </DocumentTitle>
    )
  }
}

export default GIS



// WEBPACK FOOTER //
// ./modules/shared/pages/record/propertyGIS.js